import { IPlayerNotification } from 'types/notifications';
import _Request from '../Request';
import { PaginatedResponse } from 'types';

class NotificationService extends _Request {
  constructor() {
    super('/');
  }

  getNotificationsRequest() {
    return this.send<PaginatedResponse<IPlayerNotification[]>>({ method: 'get' }, '/player/notifications/own');
  }

  getUnreadNotificationsCountRequest() {
    return this.send<number>({ method: 'get' }, '/player/notifications/count');
  }

  updateNotificationById(notificationId: number) {
    return this.send<IPlayerNotification>({ method: 'put' }, `/player/notifications/${notificationId}`);
  }

  updateNativeNotificationsToken(token: string) {
    return this.send({ method: 'put', data: { firebaseToken: token } }, '/players/firebase/token');
  }

  revokeNativeNotificationToken() {
    return this.send({ method: 'delete' }, '/players/firebase/token');
  }
}

export default new NotificationService();
